import { render, staticRenderFns } from "./AdminBoard.vue?vue&type=template&id=57b2ee08&scoped=true"
import script from "./AdminBoard.vue?vue&type=script&lang=js"
export * from "./AdminBoard.vue?vue&type=script&lang=js"
import style0 from "./AdminBoard.vue?vue&type=style&index=0&id=57b2ee08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b2ee08",
  null
  
)

export default component.exports